import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { formatValue, unformatValue } from "../../../../../PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput/utils";
import { EPaymentMethod } from "../../../../../../../../dependencies/getContent/constants";
import { produce } from "../../../../../../../../../libs/immer";
import { INPUT_LENGTH } from "../../../../../../../../../constants";
import { submitSberPayUseCase } from "../../Button/logic/submitSberPay.case";
import { checkHasPhoneInput, validatePhoneUseCase } from "./validatePhone.case";
// dependency injected factory function for sberpay phone input props
export var getMapStateToSberPayPhoneInputProps = function getMapStateToSberPayPhoneInputProps(_ref) {
  var getContent = _ref.getContent,
    submitSberPayPayment = _ref.submitSberPayPayment,
    refreshCaptcha = _ref.refreshCaptcha;
  return function (getState, setState) {
    var _state$scenario, _state$scenario2, _state$scenario$phone2, _state$scenario$phone3;
    var state = getState();
    if (((_state$scenario = state.scenario) === null || _state$scenario === void 0 ? void 0 : _state$scenario.type) !== EPaymentMethod.SberPay) throw new Error('not sberpay screen');
    var content = getContent();
    var processPhoneInput = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _state$scenario$phone;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              checkHasPhoneInput(state);
              _context.next = 3;
              return validatePhoneUseCase({
                getContent: getContent,
                getIsBeelineError: function getIsBeelineError() {
                  return Promise.resolve(undefined);
                }
              })((_state$scenario$phone = state.scenario.phoneInput.value) !== null && _state$scenario$phone !== void 0 ? _state$scenario$phone : '', setState);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function processPhoneInput() {
        return _ref2.apply(this, arguments);
      };
    }();
    return ((_state$scenario2 = state.scenario) === null || _state$scenario2 === void 0 ? void 0 : _state$scenario2.step) === 0 ? {
      disabled: false,
      onClick: function onClick() {},
      label: content.sberPayPopup.phoneInput.label,
      placeholder: content.sberPayPopup.phoneInput.placeholder,
      value: formatValue((_state$scenario$phone2 = state.scenario.phoneInput) === null || _state$scenario$phone2 === void 0 ? void 0 : _state$scenario$phone2.value),
      error: (_state$scenario$phone3 = state.scenario.phoneInput) === null || _state$scenario$phone3 === void 0 ? void 0 : _state$scenario$phone3.errorMessage,
      onEnter: function onEnter() {
        processPhoneInput().then(function () {
          setState(produce(function (draft) {
            submitSberPayUseCase({
              submitSberPayPayment: submitSberPayPayment,
              getContent: getContent,
              refreshCaptcha: refreshCaptcha
            })(function () {
              return draft;
            }, setState).catch(console.error);
          }));
        }).catch(console.error);
      },
      onChange: function onChange() {
        var _input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var input = unformatValue(_input);
        if (input.length === INPUT_LENGTH) {
          validatePhoneUseCase({
            getContent: getContent,
            getIsBeelineError: function getIsBeelineError() {
              return Promise.resolve(undefined);
            }
          })(input !== null && input !== void 0 ? input : '', setState).catch(console.error);
        }
        setState(function (prev) {
          checkHasPhoneInput(prev);
          return produce(prev, function (draft) {
            draft.scenario.phoneInput.value = unformatValue(input);
          });
        });
      },
      onBlur: processPhoneInput
    } : undefined;
  };
};